import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { routes } from '@const/routes';

export const authRoutes = [routes.signin, routes.forgot_password, routes.signup];

export const usePreviousLocation = () => {
    const location = useLocation();
    const previousLocationPathname = useRef<string | null>(null);
    const currentLocationPathname = useRef<string>(location.pathname);

    useEffect(() => {
        if (currentLocationPathname.current !== location.pathname) {
            if (!authRoutes.includes(currentLocationPathname.current)) {
                previousLocationPathname.current = currentLocationPathname.current;
            }
            currentLocationPathname.current = location.pathname;
        }
    }, [location.pathname]);

    return previousLocationPathname.current;
};
